import { GetterTree } from "vuex";
import { State } from "@/typings/store/index";
import { StateSuscripciones } from "@/typings/store/plugins/easyFirestore/suscripciones";

const getters: GetterTree<StateSuscripciones, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const suscripciones = {
  firestorePath: "suscripciones",
  firestoreRefType: "collection",
  moduleName: "suscripciones",
  statePropName: "all",
  namespaced: true,

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default suscripciones;
